export default __webpack_public_path__ + "static/media/Strategy-graph.894141cc.svg";